import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core'
import {OfferingResolved} from '../resolvers/job-request-offering.resolver'
import {ActivatedRoute, Router} from '@angular/router'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'
import {JobRequestRepository} from '../job-request.repository'
import {JobRequestService} from '../job-request.service'
import {PageComponent, PageMetadata} from '../../../../core/seo/page-metadata'
import {Observable} from 'rxjs'
import {JobRequestPageMetadataService} from '../job-request-page-metadata.service'

@Component({
  selector: 'bgo-job-request-intention',
  templateUrl: './job-request-intention.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class JobRequestIntentionComponent extends PageComponent implements OnInit {
  private readonly detailRoute = PUBLIC_ROUTES.JOB_REQUEST_DETAIL
  private readonly clientExpectationRoute = PUBLIC_ROUTES.JOB_REQUEST_CLIENT_EXPECTATION
  readonly offering: OfferingResolved = this.route.snapshot.data['offering']
  readonly intentions = this.offering!.intentions!

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly repository: JobRequestRepository,
    private readonly jobRequestService: JobRequestService,
    private readonly jobRequestPageMetadataService: JobRequestPageMetadataService,
  ) {
    super()
  }

  getPageMetadata(): Observable<PageMetadata> {
    return this.jobRequestPageMetadataService.getPageMetadataForStep('INTENTIONS', this.offering)
  }

  selectIntention(slug: string) {
    this.repository.setIntentionSlug(slug)
    this.router.navigate(
      [this.shouldAskClientExpectation() ? this.clientExpectationRoute.routingPath : this.detailRoute.routingPath],
      {
        relativeTo: this.route.parent,
        queryParamsHandling: 'merge',
      },
    )
  }

  ngOnInit(): void {
    this.jobRequestService.requestProcessDidStart(this.offering?.id)
    // Only store if offering state from same offering is not existent
    if (!this.repository.readJobRequestOfferingState()) {
      this.repository.storeJobRequestOfferingState({
        id: this.offering!.id,
        questions: [],
      })
    }
  }

  shouldAskClientExpectation() {
    const damage = this.repository.readJobRequestDamageState()
    return this.jobRequestService.shouldAskClientExpectation({offering: this.offering, damage})
  }
}
